import { render, staticRenderFns } from "./CreateEditTemplate.vue?vue&type=template&id=0a1d8e44&"
import script from "./CreateEditTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateEditTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports